// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
import type { Band } from '../types';

export const BAND_COLOR: Record<Band, string> = {
  S: '#4cc9f0',
  X: '#f5a623',
  K: '#9b59b6',
  Ka: '#e74c3c',
  Ku: '#e67e22',
  L: '#16a085',
  C: '#3498db',
  '': '#7f8c8d',
};

export const BAND_GLOSSARY_KEY: Record<Band, string> = {
  S: 'sband',
  X: 'xband',
  K: 'kband',
  Ka: 'kaband',
  Ku: 'kband',
  L: 'lband',
  C: 'cband',
  '': 'sband',
};
